import axios from 'axios'
import {apiDomain} from '../../config'

let axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
	    'token': localStorage.getItem('access_token')
	}
}

export default {
	getAll () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/invoices/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {
						var data = response.data
						resolve(data)
					} else {
						var data = response.data
						resolve(data)
					}
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	save ( model ) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/invoice/create/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},	
	getBy ( TerminalId ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/invoice/' + TerminalId + '/', { headers: {
				'Content-Type': 'application/json',
    			'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {			
						resolve(response.data)
					}else {
						resolve(response.data)

					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delete ( idTerminal ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/invoice/delete/' + idTerminal + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	restore ( idTerminal ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/invoice/restore/' + idTerminal + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					// var data = [response.data.status, response.data.message]
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	update ( idTerminal, model ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/invoice/update/' + idTerminal + '/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	get_invoices_hauls (filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/invoice/hauls/', filter_by,{ headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	addHaulsInvoice (invoiceHauls) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/invoice_hauls/', invoiceHauls, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},	
	send_invoice ( model ) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/send_haul_notification/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = response.data
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	HaulsUnasigned (invoiceHauls) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/invoice_hauls_unasigned/', invoiceHauls, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	getAll_c () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/invoice_customer/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {
						var data = response.data
						resolve(data)
					} else {
						var data = response.data
						resolve(data)
					}
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	save_IC ( model ) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/invoice_customer/create/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = response.data
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	save_IC1 ( model ) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/invoice_contract/create/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = response.data
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	save_IC2 ( model ) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/invoice_adjust/create/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = response.data
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getAll_cc () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/invoice_contract/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {
						var data = response.data
						resolve(data)
					} else {
						var data = response.data
						resolve(data)
					}
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	getAll_ca () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/invoice_adjust/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {
						var data = response.data
						resolve(data)
					} else {
						var data = response.data
						resolve(data)
					}
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	getAll_cp () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/invoice_price/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {
						var data = response.data
						resolve(data)
					} else {
						var data = response.data
						resolve(data)
					}
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	save_IC3 ( model ) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/invoice_price/create/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = response.data
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getBy_iprice ( TerminalId ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/invoice_price/' + TerminalId + '/', { headers: {
				'Content-Type': 'application/json',
    			'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {			
						resolve(response.data)
					}else {
						resolve(response.data)

					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delete_iprice ( idTerminal ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/invoice_price/delete/' + idTerminal + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	restore_iprice ( idTerminal ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/invoice_price/restore/' + idTerminal + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					// var data = [response.data.status, response.data.message]
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getBy_iadjust ( TerminalId ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/invoice_adjust/' + TerminalId + '/', { headers: {
				'Content-Type': 'application/json',
    			'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {			
						resolve(response.data)
					}else {
						resolve(response.data)

					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delete_iadjust ( idTerminal ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/invoice_adjust/delete/' + idTerminal + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	restore_iadjust ( idTerminal ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/invoice_adjust/restore/' + idTerminal + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					// var data = [response.data.status, response.data.message]
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getBy_icustomer ( TerminalId ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/invoice_customer/' + TerminalId + '/', { headers: {
				'Content-Type': 'application/json',
    			'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {			
						resolve(response.data)
					}else {
						resolve(response.data)

					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delete_icustomer ( idTerminal ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/invoice_customer/delete/' + idTerminal + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	restore_icustomer ( idTerminal ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/invoice_customer/restore/' + idTerminal + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					// var data = [response.data.status, response.data.message]
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getBy_icontract ( TerminalId ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/invoice_contract/' + TerminalId + '/', { headers: {
				'Content-Type': 'application/json',
    			'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {			
						resolve(response.data)
					}else {
						resolve(response.data)

					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delete_icontract ( idTerminal ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/invoice_contract/delete/' + idTerminal + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	restore_icontract ( idTerminal ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/invoice_contract/restore/' + idTerminal + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					// var data = [response.data.status, response.data.message]
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	update_icontract ( idTerminal, model ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/invoice_contract/update/' + idTerminal + '/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					//var data = [response.data.status, response.data.message]
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	update_iprice ( idTerminal, model ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/invoice_price/update/' + idTerminal + '/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					//var data = [response.data.status, response.data.message]
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	update_icustomer ( idTerminal, model ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/invoice_customer/update/' + idTerminal + '/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					//var data = [response.data.status, response.data.message]
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	update_iadjust ( idTerminal, model ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/invoice_adjust/update/' + idTerminal + '/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					//var data = [response.data.status, response.data.message]
					resolve(response.data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
}


// WEBPACK FOOTER //
// ./src/views/invoices/invoices_service.js